<template>
  <div>
    <v-tabs v-model="items" style="border-bottom: 1px solid lightgray">
      <v-tabs-slider></v-tabs-slider>
      <v-tab v-for="tab in tabs" :key="tab.index" class="font-weight-bold">{{
        tab.name
      }}</v-tab>
    </v-tabs>
    <v-tabs-items v-model="items" touchless>
      <v-tab-item v-for="tab in tabs" :key="tab.index">
        <component
          v-bind:is="tab.component"
          @tabmove="tabMove"
          @move-to-ai-setting="tabMove"
          :key="refresh"
          :ref-key="refresh"
          :valid_option_category="valid_option_category"
        ></component>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { ref, reactive, toRefs, onMounted, watch } from "@vue/composition-api";
import { useRouter } from "@/utils";
import selectCastComponent from "./component/selectCast.vue";
import genaiSettingComponent from "./component/genaiSetting.vue";
import HistoryComponent from "./component/history.vue";
import store from "@/store/index.js";
import utilFunc from "@/common/utilFunc.js";

export default {
  components: {
    selectCastComponent,
    genaiSettingComponent,
    HistoryComponent,
  },
  setup(props, ctx) {
    const { router } = useRouter();
    const TAB_KEY = "genai_tab_index";
    // localStorageから復元（1時間有効）、なければ0
    let tabData = {};
    try {
      tabData = JSON.parse(localStorage.getItem(TAB_KEY) || "{}");
    } catch (e) {
      tabData = {};
    }
    if (!tabData.value || !tabData.expire || tabData.expire < Date.now()) {
      localStorage.removeItem(TAB_KEY);
    }
    const items = ref(tabData.value || 0);
    const refresh = ref(1);
    const tabs = [
      {
        index: 0,
        name: "AI設定",
        component: genaiSettingComponent,
      },
      {
        index: 1,
        name: "生成履歴",
        component: HistoryComponent,
      },
      {
        index: 2,
        name: "キャスト一覧",
        component: selectCastComponent,
      },
    ];
    const state = reactive({
      valid_option_category: [],
    });

    const init = async () => {
      // 店舗チェック falseの場合ログアウトになる
      const currentShop = store.getters["shops/currentShop"];
      const currentShopData = await utilFunc.checkShopWithOption(
        currentShop.id,
        router
      );
      if (!currentShopData) return;

      // currentShopのvalid_optionを取得
      const tmp_valid_option_category = currentShopData.valid_option_category;
      if (tmp_valid_option_category != 0) {
        state.valid_option_category = tmp_valid_option_category.split(",");
      }
    };

    init();

    const tabMove = (tabIndex) => {
      items.value = tabIndex;
      const expire = Date.now() + 60 * 60 * 1000; // 1時間
      localStorage.setItem(
        TAB_KEY,
        JSON.stringify({ value: tabIndex, expire })
      );
      refresh.value++;
    };

    // タブ変更時にlocalStorageへ保存（1時間有効）
    watch(items, (val) => {
      const expire = Date.now() + 60 * 60 * 1000; // 1時間
      localStorage.setItem(TAB_KEY, JSON.stringify({ value: val, expire }));
    });

    return {
      items,
      tabs,
      tabMove,
      refresh,
      ...toRefs(state),
    };
  },
};
</script>
